import { CaretIcon, Flex, MinusIcon } from '@modusign/design-system';
import { MouseEvent } from 'react';

interface CollapseButtonProps {
  disabled?: boolean;
  isOpen?: boolean;
  testId?: string;
  onClick(): void;
}

export default function CollapseButton({
  disabled,
  isOpen = false,
  testId,
  onClick,
}: CollapseButtonProps) {
  return (
    <Flex
      alignItems="center"
      as="button"
      borderColor={disabled ? 'iconNeutralVeryLight' : 'iconNeutralLight'}
      borderRadius="3px"
      borderStyle="solid"
      borderWidth="1px"
      data-testid={testId}
      disabled={disabled}
      p={1}
      sx={{
        '&:hover:enabled': {
          backgroundColor: 'iconNeutralUltraLight',
          borderColor: 'iconNeutralDark',
        },
        ':disabled': {
          cursor: 'default',
        },
      }}
      onClick={(event: MouseEvent) => {
        event.stopPropagation();
        onClick();
      }}
    >
      {!isOpen && disabled ? (
        <MinusIcon color="iconNeutralLight" my="-2px" variant="filled" width="10px" />
      ) : (
        <CaretIcon
          color="iconNeutralDark"
          mx="1px"
          pl="2px"
          sx={{
            transition: 'ease 0.2s',
          }}
          transform={isOpen ? 'rotate(90)' : 'rotate(0)'}
        />
      )}
    </Flex>
  );
}
